import { render } from "./Pages.vue?vue&type=template&id=04161ede&scoped=true"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"

import "./Pages.vue?vue&type=style&index=0&id=04161ede&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-04161ede"

export default script